module.exports = __webpack_public_path__ + "front/img/28.70d7abdf.png";